import React, { useCallback } from 'react';

const SERVICES_INITIAL_VALUES = {
    plan_id: null,
    teams: [],
};
// TODO: consider using the AppName type out of channel_metas.tsx when #331 is merged
// https://github.com/planningcenter/topbar/pull/331/files
const INITIAL_VALUES = { Services: SERVICES_INITIAL_VALUES };
const useChatFilter = () => {
    const [filterValues, _setFilterValuesInner] = React.useState(INITIAL_VALUES);
    const setFilterValues = useCallback(({ appName, values }) => {
        _setFilterValuesInner((prevState) => ({
            ...prevState,
            [appName]: typeof values === "function" ? values(prevState[appName]) : values,
        }));
    }, []);
    return { filterValues, setFilterValues };
};

export { SERVICES_INITIAL_VALUES, useChatFilter };
//# sourceMappingURL=use_chat_filter.js.map
